module.exports = "/_next/static/images/beam-testimonial-0fdaebd8730a73989a7e6fdead674332.jpg";